// extracted by mini-css-extract-plugin
export default {"BigText":"BigText_BigText__UUmtz","Dark":"BigText_Dark__kL9se"};